module.exports = __webpack_public_path__ + "img/user.c64d67a5.jpg";